import { Modal } from '@shared/ui/Modal'
import { Button } from '@shared/ui/Button'
import { ENV } from '@shared/config/env'
import styles from './DeletePaymentMethodConfirmModal.module.css'

interface DeletePaymentMethodConfirmModalProps {
  /** Маска номера карты для подстановки в текст подтверждения */
  maskedCardNumber?: string
  isSubmitting?: boolean
  errorText?: string | null
  onConfirm: () => void
  onClose: () => void
}

export const DeletePaymentMethodConfirmModal = ({
  maskedCardNumber,
  isSubmitting = false,
  errorText,
  onConfirm,
  onClose,
}: DeletePaymentMethodConfirmModalProps) => {
  const variant = ENV.IS_TG ? 'bottomSheet' : 'center'

  const tail = maskedCardNumber
    ? maskedCardNumber.replace(/\D/g, '').slice(-4)
    : ''

  return (
    <Modal onClose={onClose} variant={variant} showClose>
      <div className={styles.content}>
        <h3 className={styles.title}>Удалить способ оплаты?</h3>
        <p className={styles.text}>
          {tail
            ? `Карта **** ${tail} будет отвязана. Это действие нельзя отменить.`
            : 'Карта будет отвязана. Это действие нельзя отменить.'}
        </p>

        {errorText && <p className={styles.error}>{errorText}</p>}

        <div className={styles.actions}>
          <button
            type="button"
            className={styles.confirmButton}
            onClick={onConfirm}
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Удаляем…' : 'Удалить'}
          </button>
          <Button
            variant="secondary"
            onClick={onClose}
            disabled={isSubmitting}
            block
          >
            Отмена
          </Button>
        </div>
      </div>
    </Modal>
  )
}
